/******************************************************************************
 * GraphQL Class
 * version: 1.0.1, release: 07.09.2018
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
******************************************************************************/

import { ApolloProvider, ApolloClient, createHttpLink, InMemoryCache, gql } from "@apollo/client";
import { setContext } from '@apollo/client/link/context';


const USER = gql`
	query USER {user(id:1){
		id
		first_name
		last_name
		language{iso}
	}}`;

// const api = {
// 	"uri" : "https://move37.jumptoday.group/api/public/graphql",
// }


//============================================================================= GraphQL Class
export class GraphQL {
	isInit	= false
	error	= null
	api		= null
	client	= null
	token	= null
	user	= null
	strategies = []


	// ------------------------------------------------------------------------ init
	async init(api, token){
		console.info('---init graphql client ...', api)
		if (!api?.uri) return console.error('no graphql-api defined!')

		this.api = api

		// this.token = api.token || localStorage.getItem('token');
		// this.token = api.token || localStorage.getItem(api.uri + '_token');
		// this.token = null
		// this.token = api.token
		// token = token || api.token
		this.token = token || api.token

		if (!this.token){
			this.client = new ApolloClient({
				uri: api.uri,
				cache: new InMemoryCache()
			});
			await this.login(api.username, api.password)
		}
		if (!this.token){
			return console.error('login error!', api)
		}

		const httpLink = createHttpLink({uri:api.uri});

		const authLink = setContext((_, { headers }) => {
			return {
				headers: {
					...headers,
					authorization: this.token ? `Bearer ${this.token}` : "",
				}
			}
		});

		this.client = new ApolloClient({
			link: authLink.concat(httpLink),
			cache: new InMemoryCache()
		});

		this.user = await this.getUser()
		this.isInit = true

		if (this.user){
			console.log('---init graphql complete!')

		}else{
			this.error = 'graphql error'
			console.log('---init graphql error!')
		}
	}

	
	// ------------------------------------------------------------------------ login
	async login(username, password){
		console.info('login', username, password, '...')
		const result = await this.client.mutate({
			variables: {
				username,
				password
			},
			mutation: gql`
				mutation userLogin($password:String!, $username:String!){
					login(input:{password:$password, username:$username}){
						access_token
					}
				}`
		}).catch(err => {
			this.error = 'graphql error: ' + err.message
			console.error('graphql error:', err)
		})

		if (result?.data?.login?.access_token){
			this.token = result.data.login.access_token;
			// localStorage.setItem('token', this.token);
			localStorage.setItem(this.api.uri + '_token', this.token);
		}

		return
	}
		

	// ------------------------------------------------------------------------ getUser
	async getUser(){
		console.log('---getUser ...')
		return await this.client.query({
			query: gql`{user(id:11){
				id
				first_name
				last_name
				language{iso}
			}}`
		}).catch(err => {
			this.error = 'graphql error: ' + err.message
			console.error('graphql error:', err)
		})
	}


	// ------------------------------------------------------------------------ getTranslations
	async getTranslations(language="de"){
		console.log('---getTranslations:', language, '...')

		const result = await this.client.query({
			variables: {language},
			query: gql`query getTranslations($language: String!) {
				getTranslations(language:$language) {
					label
					translation
				}
			}`
		}).catch(err => {
			this.error = 'graphql error: ' + err.message
			console.error('graphql error:', err)
			return null
		})
		
		return result?.data?.getTranslations
	}



  	// ------------------------------------------------------------------------ getRisks
	async getRisks(id){
		console.log('---getRisks:', id, '...')

		const result = await this.client.query({
			query: gql`{getRisks(projectId:${id}) {
					projectId
					weightedDamageValue
					value
					percentage
					children{
						projectId
						projectName
						value
						weightedDamageValue
						percentage
					}
				}
			}`
		})
		.catch(err => {
			this.error = 'graphql error: ' + err.message
			console.error('graphql error:', err)
		})

		if (result?.data?.getRisks){
			return result.data.getRisks
		}else{
			return null
		}
	}



	// ------------------------------------------------------------------------ getStrategy
	async getStrategy(id){
		console.log('---getStrategy:', id, '...')
		if (this.strategies[id]) return this.strategies[id]

		const result = await this.client.query({
			query: gql`{strategy(id:${id}) {
				id
				name
				client {
					logoAsset {
						thumb_url
						url
					}
				}
				projects {
					id
					name
					type
					class
					status
					nps
					start_date
					end_date
					lead_user_id
					users {
						id
						first_name
						last_name
						email
						avatarAsset {
							thumb_url
						}
						role {
							name
						}
						userProjectRoles {
							strategy_id
							value
						}
					}
					childs {
						id
						name
						type
						class
						status
						nps
						sponsor {
							first_name
							last_name
							email
							avatarAsset {
								thumb_url
							}
						}
						description
						effects
						benefits
						todos
						investment
						results
						start_date
						end_date
						users {
							id
							first_name
							last_name
							email
							avatarAsset {
								thumb_url
							}
							role {
								name
							}
							userProjectRoles {
								strategy_id
								value
							}
						}
						dependencies {
							pivot {
								source_project_id
								target_project_id
								description
								type
							}
						}
						resources {
							values {
								value
							}
						}
						investments {
							values {
								value
							}
						}
						values {
							type
							values {
								value
							}
						}
						risks {
							values {
								value
							}
						}
						activities {
							progress
						}
						childs {
							id
							name
							type
							class
							status
							nps
							sponsor {
								first_name
								last_name
								avatarAsset {
									thumb_url
								}
							}
							description
							effects
							benefits
							todos
							investment
							results
							start_date
							end_date
							users {
								id
								first_name
								last_name
								email
								avatarAsset {
									thumb_url
								}
								role {
									name
								}
								userProjectRoles {
									strategy_id
									value
								}
							}
							dependencies {
								pivot {
									source_project_id
									target_project_id
									description
									type
								}
							}
							resources {
								values {
									value
								}
							}
							investments {
								values {
									value
								}
							}
							values {
								type
								values {
									value
								}
							}
							risks {
								values {
									value
								}
							}
							activities {
								progress
							}
							childs {
								id
								name
								type
								class
								status
								nps
								sponsor {
									first_name
									last_name
									avatarAsset {
										thumb_url
									}
								}
								description
								effects
								benefits
								todos
								investment
								results
								start_date
								end_date
								users {
									id
									first_name
									last_name
									email
									avatarAsset {
										thumb_url
									}
									role {
										name
									}
									userProjectRoles {
										strategy_id
										value
									}
								}
								dependencies {
									pivot {
										source_project_id
										target_project_id
										description
										type
									}
								}
								resources {
									values {
										value
									}
								}
								investments {
									values {
										value
									}
								}
								values {
									type
									values {
										value
									}
								}
								risks {
									values {
										value
									}
								}
								activities {
									progress
								}
							}							
						}
					}
				}
			}}`
		})
		.catch(err => {
			this.error = 'graphql error: ' + err.message
			console.error('graphql error:', err)
		})

		if (result?.data?.strategy){
			this.strategies[id] = result.data.strategy
			return this.strategies[id]
		}else{
			return null
		}
	}
}
